import { type Comparator, type Operator, queryBuilder } from '@inpart-io/devtools-iap';
import { RETRIEVE_BY_QUERY } from '@inpart-io/devtools-vue';
import { DataType, type ICriteria, type ILayout, type ILayoutField, type ISection, type ISubSection } from '@inpart-io/padme-iap';
import { layoutProperties } from '@inpart-io/padme-iap';

import { layoutDataTypeCriteriaAttributes } from '@/pages/platform-settings/components/layout/constants/layout-settings.constants';
import { getCriteriaList } from '@/pages/platform-settings/components/layout/services/fields-management-service';
import { store } from '@/store';
import { LAYOUT_MODULE } from '@/store/layout-module';

/**
 * Retrieve the array of ILayout applicable for classNames with a value criteria
 */
export async function retrieveObjectLayouts(classNames: DataType[], value?: string | number, additionalCriteria?: ICriteria[]): Promise<number[]> {
    const primaryClassName = classNames[0] === DataType.LeadProfile ? DataType.Lead : classNames[0];
    const valueComp = `${layoutDataTypeCriteriaAttributes[primaryClassName]}:${value}`;

    const operators: Operator[] = [];

    const classNamesComparators = [queryBuilder.cmp.equalTo('forClassName', primaryClassName), queryBuilder.cmp.equalTo('criteriaList', valueComp)];
    operators.push(queryBuilder.op.and(...classNamesComparators));

    if (classNames.includes(DataType.LeadProfile)) {
        const assetComparators = [queryBuilder.cmp.equalTo('forClassName', DataType.LeadProfile), queryBuilder.cmp.equalTo('criteriaList', valueComp)];

        if (additionalCriteria && additionalCriteria.length > 0) {
            const otherComparators: Comparator[] = [];
            for (const criterion of getCriteriaList(additionalCriteria)) {
                otherComparators.push(queryBuilder.cmp.equalTo('criteriaList', criterion));
            }

            assetComparators.push(...otherComparators);
        }
        operators.push(queryBuilder.op.and(...assetComparators));
    }
    const query = queryBuilder.build(queryBuilder.op.or(...operators));
    return (
        store.dispatch(`${LAYOUT_MODULE}/${RETRIEVE_BY_QUERY}`, {
            query,
            properties: layoutProperties.DEFAULT
        }) ?? []
    );
}

/**
 * Checks if given infogroup field is in given layout
 */
export function isInfogroupFieldInLayout(infogroupFieldKey: string, layouts: ILayout[]): boolean {
    for (const layout of layouts) {
        if (
            layout?.sections?.some((section: ISection) => {
                return section?.subsections?.some((subsection: ISubSection) => {
                    return subsection.fields?.some((field: ILayoutField) => {
                        return field.fieldKey === infogroupFieldKey;
                    });
                });
            })
        ) {
            return true;
        }
    }
    return false;
}
